var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(-407.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.6211,37.1646 C448.3691,36.3886 447.9321,35.6776 447.3241,35.0346 C446.6871,34.3626 445.8501,33.8426 444.8121,33.4666 C443.7731,33.0936 442.4391,32.9046 440.7951,32.9046 L438.5641,32.9046 C438.8301,30.1586 439.8081,27.8216 441.5001,25.8896 C443.1891,23.9636 445.5311,22.2686 448.5251,20.8146 L446.7091,18.0006 C442.7671,19.6796 439.3941,22.1356 436.5921,25.3796 C433.7911,28.6266 432.3961,31.8436 432.3961,35.0346 C432.3961,38.4626 433.2051,41.1516 434.8361,43.0926 C436.4671,45.0336 438.8031,46.0006 441.8401,46.0006 C443.7671,46.0006 445.4411,45.3576 446.8651,44.0726 C448.2871,42.7896 449.0001,41.2866 449.0001,39.5726 C449.0001,38.7456 448.8751,37.9406 448.6211,37.1646 M428.2251,37.1646 C427.9711,36.3886 427.5351,35.6776 426.9261,35.0346 C426.2911,34.3626 425.4531,33.8426 424.4141,33.4666 C423.3771,33.0936 422.0431,32.9046 420.3981,32.9046 L418.1661,32.9046 C418.4331,30.1586 419.4101,27.8216 421.1011,25.8896 C422.7911,23.9636 425.1351,22.2686 428.1271,20.8146 L426.3121,18.0006 C422.3691,19.6796 418.9981,22.1356 416.1951,25.3796 C413.3941,28.6266 412.0001,31.8436 412.0001,35.0346 C412.0001,38.4626 412.8071,41.1516 414.4391,43.0926 C416.0681,45.0336 418.4041,46.0006 421.4431,46.0006 C423.3691,46.0006 425.0451,45.3576 426.4691,44.0726 C427.8911,42.7896 428.6031,41.2866 428.6031,39.5726 C428.6031,38.7456 428.4761,37.9406 428.2251,37.1646",
    fill: "#000000",
    id: "quote2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "slices",
    transform: "translate(47.000000, 9.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.7c57de476a7703551c81cc04af058d00.svg";
export { ForwardRef as ReactComponent };